import { requestTemplate } from 'api';
import { IDataRoom } from 'interfaces';

//ROOMS
const getUserRooms = () => requestTemplate.get<IDataRoom[]>('/rooms/v3/');
const getRoom = (id: string) => requestTemplate.get<IDataRoom>(`/rooms/${id}/`);
const checkCustomUrl = (url: string) => requestTemplate.get<{ available: boolean }>(`/rooms/url_check/?url=${url}`);
const deleteSelectedUser = (user_id: string, room_id: string) => requestTemplate.delete<string>(`/rooms/user/?user_id=${user_id}&room_id=${room_id}`);
const changeBlockStatus = (payload: {user_ids: string[], room_id: string, is_blocked: boolean}) => requestTemplate.put<string>(`/users/rooms/block/`, payload);

const createRoom = (payload: FormData) => requestTemplate.post<IDataRoom>(`/rooms/?action=create`, payload, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

const createRoomV2 = (payload: FormData) => requestTemplate.post<IDataRoom>(`/rooms/v2/?action=create`, payload, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

const setRoomSettings = (
  payload: FormData, roomId: string, action: string, document_name: string
) => requestTemplate.put<IDataRoom>(`/rooms/?id=${roomId}&action=${action}&document_name=${document_name}`, payload, {
  headers: { 'Accept': 'application/json', 'Content-Type': 'multipart/form-data' } 
});

const setRoomAgreement = (payload: FormData) => requestTemplate.post<any>(`/rooms/agreement/`, payload, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

const deleteRoomAgreementFile = (payload: { room_id: string }) =>
  requestTemplate.delete<void>(`/rooms/agreement/?room_id=${payload.room_id}`);

const uploadNDAVersion = (payload: FormData) =>
  requestTemplate.post<any>('/rooms/agreement/version/', payload, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

const getNDAVersions = (payload: { room_id: string }) =>
  requestTemplate.get<any[]>('/rooms/agreement/version/', { params: payload });

const ndaVersionReset = (payload: { room_id: string; version_id: string; comment: string }) =>
  requestTemplate.post('/rooms/agreement/version/reset/', payload);

const setRoomAgreementState = (room_id: string) => requestTemplate.get<any>(`/documents/agreement/?room_id=${room_id}`);

const addOrganizationToSide = (
  payload: {room_id: string, organization_id: string}
) => requestTemplate.post<{ message: string }>(`/rooms/organization/add/`, payload);


const deleteRoom = (
  payload: { room_id: string },
) => requestTemplate.delete<any>(`/rooms/`,  { data: payload });

const toggleRoomWatermark = (payload: { id: string; enable: boolean }) =>
  requestTemplate.post<{ success: true; detail: 'Watermark was enabled successfully' }>('/rooms/watermark/', payload);

const getRoomsAnalytics = (payload: { room?: string, from?: string, to?: string }) =>
  requestTemplate.get(`/analytics/data/`, {params: payload});

const getRoomsPermissions = (payload: { room_id: string }) =>
  requestTemplate.get(`/permissions/by_room/`, {params: payload});

const getRoomMessengerKey = (payload: { room_id: string, messenger: string }) =>
  requestTemplate.get(`/messengers/room/${payload.room_id}/?messenger=${payload.messenger}`);

const rooms = {
  getUserRooms,
  getRoom,
  checkCustomUrl,
  deleteSelectedUser,
  changeBlockStatus,
  createRoom,
  createRoomV2,
  setRoomSettings,
  setRoomAgreementState,
  addOrganizationToSide,
  deleteRoom,
  toggleRoomWatermark,
  setRoomAgreement,
  deleteRoomAgreementFile,
  uploadNDAVersion,
  getNDAVersions,
  ndaVersionReset,
  getRoomsAnalytics,
  getRoomsPermissions,
  getRoomMessengerKey
};

export default rooms;
